import usePage from '@/gf/hooks/usePage'
import Time from '@/gf/modules/Time'
import useSearchOrganizations from '../hooks/useSearchOrganizations'

import Layout from '@/gf/components/Layout'
import Link from '@/gf/components/LinkOld'
import Page from '@/gf/components/Page'
import Pagination from '@/gf/components/Pagination'
import Spinner from '@/gf/components/Spinner'
import { Table, Tbody, Td, Th, Thead, Tr } from '@/gf/components/Table'
import Frame from '../components/Frame'
import Menu from './Customers/Menu'

const breadcrumbs = {
  copy: 'Back to Dashboard',
  crumbs: [{ name: 'Accounts', href: '/accounts' }],
}

const cols = 5

const Accounts = () => {
  const [page, setPage] = usePage()
  const searchResults = useSearchOrganizations({ variables: { page } })
  const search = searchResults.data?.customerOrganizations

  return (
    <Frame breadcrumbs={breadcrumbs}>
      <Page title="Customers">
        <Menu />
        <Layout>
          <Layout.Section type="table">
            <Table>
              <Thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Phone</Th>
                  <Th className="text-center">Open Orders</Th>
                  <Th className="text-center">Completed Orders</Th>
                  <Th>Last Activity Date</Th>
                </Tr>
              </Thead>
              <Tbody>
                {search?.organizations.map((org) => (
                  <Tr key={org.id}>
                    <Td>
                      <Link to={`/accounts/${org.id}`}>{org.name}</Link>
                    </Td>
                    <Td>{org.phoneNumber}</Td>
                    <Td className="text-center">{org.openOrdersCount.toLocaleString()}</Td>
                    <Td className="text-center">{org.closedOrdersCount.toLocaleString()}</Td>
                    <Td>{org.lastActivityDate ? Time.toString(org.lastActivityDate) : ''}</Td>
                  </Tr>
                ))}

                {!search && (
                  <Tr>
                    <Td colSpan={cols}>
                      <Spinner />
                    </Td>
                  </Tr>
                )}

                {search?.organizations.length === 0 && (
                  <Tr>
                    <Td colSpan={cols}>No accounts found.</Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </Layout.Section>
          <Layout.Section type="full">
            <Pagination pagination={search?.pagination} page={page} updatePage={setPage} />
          </Layout.Section>
        </Layout>
      </Page>
    </Frame>
  )
}

export default Accounts
